import { Select as Slct } from "@mantine/core";
import React from "react";

const Select = ({
  allowDeselect,
  clearButtonLabel,
  clearButtonTabIndex,
  clearable,
  creatable,
  data,
  defaultValue,
  description,
  descriptionProps,
  disabled,
  dropdownComponent,
  dropdownPosition,
  error,
  errorProps,
  filter,
  getCreatableLabel,
  icon,
  iconWidth,
  label,
  limit,
  maxDropdownHeight,
  onChange,
  onCreate,
  onDropdownClose,
  onDropdownOpen,
  onSearchChange,
  onValueChange,
  radius,
  required,
  size = "md",
  selectOnBlur,
  value,
  variant,
  withAsterisk,
  zIndex,
  form,
  validateName,
  placeholder,
  p,
  py,
  px,
  pt,
  pb,
  pl,
  pr,
  m,
  my,
  mx,
  mt = "xs",
  mb,
  ml,
  mr,
  padding = "1.4rem 0.75rem",
  searchable,
  itemComponent,
  onInput,
  nothingFound = "No results found",
  style,
  styles,
}) => {
  return (
    <Slct
      pt={pt}
      mt={mt}
      styles={{
        ...styles,
        input: {
          padding: { padding },
          ...styles?.input,
        },
      }}
      style={style}
      onInput={onInput}
      filter={filter}
      itemComponent={itemComponent}
      nothingFound={nothingFound}
      placeholder={placeholder}
      allowDeselect={allowDeselect}
      clearButtonLabel={clearButtonLabel}
      clearButtonTabIndex={clearButtonTabIndex}
      clearable={clearable}
      creatable={creatable}
      data={data}
      searchable={searchable}
      defaultValue={defaultValue}
      description={description}
      descriptionProps={descriptionProps}
      disabled={disabled}
      dropdownComponent={dropdownComponent}
      dropdownPosition={dropdownPosition}
      error={error}
      errorProps={errorProps}
      getCreatableLabel={getCreatableLabel}
      icon={icon}
      iconWidth={iconWidth}
      label={label}
      limit={limit}
      maxDropdownHeight={maxDropdownHeight}
      onChange={onChange}
      onCreate={onCreate}
      onDropdownClose={onDropdownClose}
      onDropdownOpen={onDropdownOpen}
      onSearchChange={onSearchChange}
      onValueChange={onValueChange}
      radius={radius}
      required={required}
      size={size}
      selectOnBlur={selectOnBlur}
      value={value}
      variant={variant}
      withAsterisk={withAsterisk}
      zIndex={zIndex}
      {...form?.getInputProps(validateName)}
    ></Slct>
  );
};

export default Select;
